
import React from 'react';
import {VimeoVideo} from './types';
import PlayerIFrame from './PlayerIFrame';
import {FixedAspectRatioDiv} from '@rcm/fixed-aspect-ratio-div-react';
interface Props {
    video: VimeoVideo;
}
export default ({video}: Props) => {
    return <FixedAspectRatioDiv aspectRatio={`${video.width}:${video.height}`}>
        <PlayerIFrame videoId={video.id}/>
    </FixedAspectRatioDiv>;
};
